<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onEditAndSaveClick)="doEditAndSave($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div >
    <app-jkedit  label="功能分類" #SH011Com  id="SH011"  [(value)]="item.SH011" placeholder="功能分類"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px"
 label="html內容" #SH019Com  id="SH019"  [(value)]="item.SH019" placeholder="html內容"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkcheckboxYN  label="註記碼" #SH018Com  id="SH018"  [(valueYN)]="item.SH018"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jktextarea  height="250px"
 label="說明" #SH017Com  id="SH017"  [(value)]="item.SH017" placeholder="說明"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkcheckboxYN  label="客製程式碼" #SH016Com  id="SH016"  [(valueYN)]="item.SH016"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkcheckboxYN  label="生效碼" #SH015Com  id="SH015"  [(valueYN)]="item.SH015"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkedit  label="用於系統" #SH014Com  id="SH014"  [(value)]="item.SH014" placeholder="用於系統"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="建檔者代號" #SH013Com  id="SH013"  [(value)]="item.SH013" [required]="true"  placeholder="建檔者代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktext  label="序號" [value]="item.SH012"     >
    </app-jktext>
    <app-jkedit  label="程式代號" #SH001Com  id="SH001"  [(value)]="item.SH001" [required]="true"  placeholder="程式代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="功能簡介" #SH010Com  id="SH010"  [(value)]="item.SH010" placeholder="功能簡介"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="版次" #SH009Com  id="SH009"  [(value)]="item.SH009" placeholder="版次"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="文管代號" #SH008Com  id="SH008"  [(value)]="item.SH008" placeholder="文管代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkcombobox  label="類型" #SH006Com  id="SH006"  [(value)]="item.SH006" placeholder="類型"  [readonly]="isBrowse"  [items]="srv.SysSh006List"   >
    </app-jkcombobox>
    <app-jktextarea  height="250px"
 label="備註" #SH004Com  id="SH004"  [(value)]="item.SH004" placeholder="備註"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkedit  label="網址/檔名" #SH003Com  id="SH003"  [(value)]="item.SH003" placeholder="網址/檔名"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="名稱" #SH002Com  id="SH002"  [(value)]="item.SH002" placeholder="名稱"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-milkdown-markdown-editor [markdown]="textContent()" [readonly]="true" [showToolbar]="false" />
          @if (imageUrl()) { <app-jk-image-viewer [src]="imageUrl()"  /> }

    </div>
  </div>
</div>
